/** Shopify supplier inventory from sync metadata (not warehouse unit count). */
export const getSupplierStock = (template: {
  specifications?: Record<string, unknown> | null;
}): number => {
  const qty = template.specifications?.total_inventory_quantity;
  return typeof qty === 'number' && Number.isFinite(qty) ? qty : 0;
};
